import React from 'react';

const ChangePassword = () => {
  return <>Hello user ChangePassword</>;
};

export default ChangePassword;
